import React, { useState, useMemo, useEffect } from "react";
import {
  Box,
  AppBar,
  Toolbar,
  Link,
  Typography,
  IconButton,
  Tooltip,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import {
  Link as RouterLink,
  useNavigate,
  useParams,
  createSearchParams,
  useSearchParams,
  useLocation,
} from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import { decrypt } from "../utils/cryptoHelper";
import LogoutIcon from "@mui/icons-material/Logout";
import { logout } from "../api/user";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";

const AppHeader = ({ moduleAppBar, colorMode, toggleColorMode }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [projectName, setProjectName] = useState();
  const [searchParams, setSearchParams] = useSearchParams();
  const projectId = searchParams.get("id");
  const [dialogOpen, setDialogOpen] = useState(false);
  console.log("----dialogOpen-----", dialogOpen);

  useEffect(() => {
    console.log(projectId);
    if (window.localStorage.getItem("project")) {
      const project = JSON.parse(
        decrypt(window.localStorage.getItem("project"))
      );
      console.log("project", project);
      setProjectName(project.PROJ_NAME);
    } else {
      setProjectName();
    }
  }, [projectId]);

  const appBarStyles = useMemo(
    () => ({
      zIndex: `${theme.zIndex.drawer + 1} !important`,
    }),
    [theme]
  );

  const toolbarStyles = useMemo(
    () => ({
      height: "64px !important",
      overflowY: "visible",
      backgroundColor: theme.palette.background.default,
      display: "flex",
      justifyContent: "space-between",
    }),
    [theme]
  );

  const navigateToPage = () => {
    navigate(`/modules/Project`);
  };

  const renderMainAppBar = () => (
    <AppBar sx={appBarStyles}>
      <Toolbar sx={toolbarStyles}>
        <Box display="flex" alignItems="center">
          <img height={32} alt="logo" src="assets/logos/smartLogo_text.png" />
        </Box>
      </Toolbar>
    </AppBar>
  );

  const renderModuleAppBar = () => (
    <AppBar sx={appBarStyles}>
      <Toolbar sx={toolbarStyles}>
        <Box
          display="flex"
          alignItems="center"
          sx={{ backgroundColor: theme.palette.background.paper, width: 180, height: "100%", pl: 3 }}
        >
          <Link component={RouterLink} to="/" sx={{ display: "contents" }}>
            <img
              width={90}
              alt="logotext"
              src="assets/logos/smartLogo_text.png"
            />
          </Link>
          <Typography
            variant="h5"
            sx={{
              whiteSpace: "nowrap",
              ml: 4,
              fontWeight: 600,
              color: theme.palette.primary.main,
            }}
          >
            {projectName}
          </Typography>
        </Box>

        <Box sx={{ display: "flex" }}>
          <Box>
            <Tooltip
              title={colorMode === "dark" ? "Switch to light mode" : "Switch to dark mode"}
              placement="bottom"
              arrow
            >
              <IconButton onClick={toggleColorMode}>
                {colorMode === "dark" ? (
                  <LightModeOutlinedIcon />
                ) : (
                  <DarkModeOutlinedIcon />
                )}
              </IconButton>
            </Tooltip>
          </Box>
          <Box>
            <Tooltip title={"Account"} placement="bottom" arrow>
              <IconButton
                onClick={() =>
                  navigate({
                    pathname: `/modules/account`,
                  })
                }
              >
                <AccountCircleOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Box>
          <Box>
            <Tooltip title={"Logout"} placement="bottom" arrow>
              <IconButton onClick={() => setDialogOpen(true)}>
                <LogoutIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Toolbar>

      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <DialogTitle>Logout</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to logout?
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>Cancel</Button>
          <Button
            onClick={async () => {
              await logout();
              setDialogOpen(false);
              window.localStorage.clear();
              navigate("/");
            }}
          >
            Logout
          </Button>
        </DialogActions>
      </Dialog>
    </AppBar>
  );

  return moduleAppBar ? renderModuleAppBar() : renderMainAppBar();
};

export default AppHeader;
